module.exports = __webpack_public_path__ + "static/img/MATTHEW-LERAY.f014bdf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/MATTHEW-LERAY.jpg
// module id = DB4i
// module chunks = 0